import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useFlag } from '@unleash/proxy-client-react';
import { useSolana } from '../../hooks/useSolana';
import { debounce } from 'lodash';
import { PHONE_MEDIA_QUERY, useMediaQuery } from '../../common/responsive';
import { openModal } from '../../redux/slices/modals';
import { useDispatch, useSelector } from 'react-redux';
import { useGetCurrentGiveAwayQuery } from '../../redux/api/authorized/giveAway';
import { selectPrivyToken } from '../../redux/slices/auth';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { usePrivy } from '@privy-io/react-auth';
import { hapticsImpactLight } from '../../common/haptic';
import useCustomLogin from '../../hooks/useCustomLogin';
import { BREAKPOINT_BANNER_CLICKED, sendEvent } from '../../common/analytics';

const Banner = styled.img`
  width: 100%;
  cursor: pointer;
  margin-top: 8px;
`;

const Banners = () => {
  const debitCardBanner = useFlag('debitCardBanner');
  const { refreshTokenBalances } = useSolana();
  const [balancesRefreshed, setBalancesRefreshed] = useState(false);
  const dispatch = useDispatch();
  const { login } = useCustomLogin();
  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);
  const breakpointRaffleEnabled = useFlag('enableBreakpointRaffle');
  const privyToken = useSelector(selectPrivyToken);
  const { data: currentGiveAway } = useGetCurrentGiveAwayQuery(undefined, {
    skip: !privyToken,
  });

  useEffect(() => {
    if (!refreshTokenBalances || balancesRefreshed) return;
    const debouncedRefresh = debounce(() => {
      refreshTokenBalances();
      setBalancesRefreshed(true);
    }, 500);
    debouncedRefresh();
    return () => {
      debouncedRefresh.cancel();
    };
  }, [refreshTokenBalances, balancesRefreshed]);

  const banners = [
    // {
    //   onClick: () => {
    //     if (privyToken) {
    //       dispatch(openModal({ name: 'referrals' }));
    //     } else {
    //       login();
    //     }
    //   },
    //   src: isMobile ? '/referral/mobile-banner.webp' : '/referral/desktop-banner.webp'
    // }
  ];

  if (breakpointRaffleEnabled) {
    banners.push({
      onClick: () => {
        sendEvent(BREAKPOINT_BANNER_CLICKED);
        dispatch(openModal({ name: 'breakpointRaffle' }));
      },
      src: isMobile
        ? '/breakpoint/mobile-banner.webp'
        : '/breakpoint/desktop-banner.webp',
    });
  }

  if (debitCardBanner) {
    banners.push({
      onClick: () => {
        if (privyToken) {
          dispatch(openModal({ name: 'debitCardWaitlist' }));
        } else {
          login();
        }
      },
      src: isMobile
        ? '/debit-card/mobile-banner.webp'
        : '/debit-card/desktop-banner.webp',
    });
  }

  if (currentGiveAway) {
    banners.push({
      onClick: () => {
        if (privyToken) {
          dispatch(
            openModal({
              name: 'giveAway',
              props: { giveAwayId: currentGiveAway.id },
            }),
          );
        } else {
          login();
        }
      },
      src: isMobile
        ? currentGiveAway.mobileBanner
        : currentGiveAway.desktopBanner,
    });
  }

  return (
    <div style={{ marginBottom: -20 }}>
      {banners.length > 0 && (
        <Carousel
          onClickItem={(index) => {
            hapticsImpactLight();
            banners[index].onClick();
          }}
          infiniteLoop
          autoPlay
          interval={5000}
          showStatus={false}
        >
          {banners.map((banner) => (
            <Banner src={banner.src} />
          ))}
        </Carousel>
      )}
    </div>
  );
};

export default Banners;
